export type Category = 'energy' | 'circularity' | 'carbon_removal' | 'aviation' | 'mobility';

export type Action = 'link' | 'popup';

export interface Point {
	id: string;
	x: number;
	y: number;
	category: Category | null;
	code: string;
	title: string;
	action: Action | null;
	url: string;
	target: string;
	popupHtml: string;
	buttonUrl: string;
	buttonTitle: string;
	buttonTarget: string;
}

export interface MapData {
	image: string;
	width: number;
	height: number;
	points: Point[];
}

const categories: readonly Category[] = ['energy', 'circularity', 'carbon_removal', 'aviation', 'mobility'];

export function isCategory(value: string): value is Category {
	return (categories as readonly string[]).includes(value);
}

export function categoryClass(category: Category): string {
	const name = category === 'carbon_removal' ? 'carbon-removal' : category;
	return `tulips-kaart__hotspot__callout__badge--${name}`;
}
